import messages from '../../../locales/messages';
import { Link, ClickableTile } from 'carbon-components-react';
import './interactiveDemo.scss';
import { ArrowRight32 } from '@carbon/icons-react';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';

type TilesProps = {
  functionToExecute: () => void;
  id: string;
  className: string;
  bodyText: string;
};

const LMTile = ({ functionToExecute, id, className, bodyText }: TilesProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <ClickableTile
        className="LMTile"
        role="button"
        onClick={() => {
          functionToExecute();
        }}
      >
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sd-4">
            <p className="textSubTile">{useTranslation(bodyText)}</p>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sd-4">
            <Link
              role="button"
              className="bx-link-class arrowIMG"
              id="se-next-step-id"
              rel="noreferrer"
              renderIcon={() => <ArrowRight32 className="Image" />}
              onClick={() => {
                console.log('Learn More');
                functionToExecute();
              }}
            />
          </div>
        </div>
      </ClickableTile>
    </>
  );
};

type InteractiveDemoProps = {
  wxai_Trial: () => void;
  wxOrchestrateTrial: () => void;
};
export const InteractiveDemo = ({
  wxai_Trial,
  wxOrchestrateTrial,
}: InteractiveDemoProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <p className="interactive_subtitle">
              {useTranslation('interactive_subtitle')}
            </p>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-4 bx--col-md-2 bx--col-sm-4">
            <LMTile
              id="01"
              className="HH"
              bodyText="interactive_tile01"
              functionToExecute={wxOrchestrateTrial}
            />
          </div>
          <div className="bx--col-lg-4 bx--col-md-2 bx--col-sm-4">
            <LMTile
              id="01"
              className="HH"
              bodyText="interactive_tile02"
              functionToExecute={wxai_Trial}
            />
          </div>
        </div>
      </div>
    </>
  );
};
